import classNames from "classnames"
import { motion } from "motion/react"

import styles from "./index.module.less"

interface Props {
    className?: string
    style?: React.CSSProperties
}

const Curtain: React.FC<Props> = (props) => {
    const { className, style } = props

    return (
        <motion.div
            initial={{
                transform: "translateY(-100%)",
                opacity: 0,
                pointerEvents: "none",
            }}
            animate={{
                transform: "translateY(0)",
                opacity: 1,
                pointerEvents: "auto",
            }}
            transition={{
                duration: 0.5,
                delay: 0.3,
                ease: "easeInOut",
            }}
            className={classNames(styles.curtain, className)}
            style={style}
        />
    )
}

export default Curtain
